import { render, staticRenderFns } from "./header-row.vue?vue&type=template&id=4df87c5e&"
import script from "./header-row.vue?vue&type=script&lang=js&"
export * from "./header-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports